import { render, staticRenderFns } from "./OverviewProduction.vue?vue&type=template&id=f38da15a&scoped=true&"
import script from "./OverviewProduction.vue?vue&type=script&lang=js&"
export * from "./OverviewProduction.vue?vue&type=script&lang=js&"
import style0 from "./OverviewProduction.vue?vue&type=style&index=0&id=f38da15a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38da15a",
  null
  
)

export default component.exports